import images from "./images";

const home = [
  {
    id: 1,
    image: images.home1,
    subtitle: "Welcome to BlazeGuard",
    title: "Ensuring {Community Safety} with Fire Prevention",
    buttonText: "Contact Us",
    buttonLink: "Contact-us",
  },
  {
    id: 2,
    image: images.home2,
    subtitle: "Welcome to BlazeGuard",
    title: "Promoting {Fire Safety Education} for All Ages",
    buttonText: "Contact Us",
    buttonLink: "Contact-us",
  },
  {
    id: 3,
    image: images.home3,
    subtitle: "Welcome to BlazeGuard",
    title: "Emergency Response with {Swift and Effective Actions}",
    buttonText: "Contact Us",
    buttonLink: "Contact-us",
  },
];

export default home;